import { PRIVATE_API_ROUTES } from "../constants";
import Http from "./http-service";

import {
  downloadReports,
  getLocalizedMessage,
} from "../UtilityFunctions/utils";
import { showNotification } from "../UtilityFunctions/notification";
import { setLoading } from "../globalContext/globalLoader/globalLoaderAction";
import {
  getAuditList as getAuditListAction,
  setAuditErrorCode,
  setAuditQuestionnaireDetailById,
} from "../globalContext/ManageAudit/auditActions";
import {
  AUDIT_IN_PROGRESS,
  AUDIT_LINK_TOKEN_EXPIRE,
  AUDIT_MEDIUM_NOT_MATCH,
  AUDIT_ON_HOLD,
  NO_PARTICIPANT_FOUND,
  NO_QUESTIONNAIRE,
  NO_QUESTIONNAIRE_ASSIGNED,
  OPERATIONAL_PRIMARY,
  QUESTIONNAIRE_NOT_EVALUATED,
} from "../constants/errorConstants";

class AuditService {
  static async getProductSubProductList({ intl, loaderDispatch }) {
    loaderDispatch(setLoading(true));
    return Http.get(PRIVATE_API_ROUTES.PRODUCT_AND_SUB_CATEGORY_LIST)
      .then(({ data }) => {
        loaderDispatch(setLoading(false));
        return Promise.resolve(data?.data?.result);
      })
      .catch((error) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.reject(error);
      });
  }

  static async planAudit({ intl, body, loaderDispatch, callback }) {
    loaderDispatch(setLoading(true));
    return Http.post(PRIVATE_API_ROUTES.PLAN_AUDIT, body)
      .then((res) => {
        loaderDispatch(setLoading(false));
        showNotification("success", "Success", "Saved successfully");
        return Promise.resolve(res?.data);
      })
      .catch((err) => {
        loaderDispatch(setLoading(false));
        if (
          err?.response?.data?.code === NO_QUESTIONNAIRE ||
          err?.response?.data?.code === OPERATIONAL_PRIMARY
        ) {
          callback(err?.response?.data?.code);
        } else if (err?.response?.data?.code === AUDIT_IN_PROGRESS) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.auditAlreadyInProgress", {
              name: err?.response?.data?.message?.split("=")?.[1],
            })
          );
        } else {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.somethingWentWrong")
          );
        }
        return Promise.reject(err);
      });
  }

  static async getAuditList({ intl, params, loaderDispatch, dispatch }) {
    loaderDispatch(setLoading(true));
    return Http.get(PRIVATE_API_ROUTES.AUDIT_LIST, params)
      .then(({ data }) => {
        loaderDispatch(setLoading(false));
        dispatch(getAuditListAction(data?.data));
        return Promise.resolve(data?.data);
      })
      .catch((err) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.reject(err);
      });
  }

  static async getUsersList({ params, intl, loaderDispatch }) {
    loaderDispatch(setLoading(true));
    return Http.get(PRIVATE_API_ROUTES.USER_LISTING, params)
      .then(({ data }) => {
        loaderDispatch(setLoading(false));
        return Promise.resolve(data?.data?.result);
      })
      .catch((errors) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.reject(errors);
      });
  }

  static async getDownloadAuditReports({ params, intl, loaderDispatch }) {
    loaderDispatch(setLoading(true));
    return Http.get(
      PRIVATE_API_ROUTES.DOWNLOAD_AUDIT_REPORTS,
      params,
      () => {}, //NOSONAR
      "blob"
    )
      .then((res) => {
        loaderDispatch(setLoading(false));
        downloadReports(res);
      })
      .catch(() => {
        loaderDispatch(setLoading(false));
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
      });
  }

  static async setAuditMediumType({ auditId, intl, loaderDispatch, body }) {
    loaderDispatch(setLoading(true));
    return Http.put(PRIVATE_API_ROUTES.SET_AUDIT_MEDIUM(auditId), body)
      .then((res) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "success",
          "Success",
          getLocalizedMessage(intl, "savedSuccessFully")
        );
        return Promise.resolve(res?.data);
      })
      .catch((err) => {
        loaderDispatch(setLoading(false));
        if (err?.response?.data?.code === QUESTIONNAIRE_NOT_EVALUATED) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(
              intl,
              "auditCompleted.evaluationStatusNotFilled"
            )
          );
        } else {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.somethingWentWrong")
          );
        }

        return Promise.resolve(err);
      });
  }

  static async getAuditQuestionnaireById({
    auditDispatch,
    loaderDispatch,
    auditId,
    intl,
  }) {
    if (loaderDispatch) loaderDispatch(setLoading(true));
    return Http.get(
      `${PRIVATE_API_ROUTES.AUDIT_QUESTIONNAIRE_BY_ID}/${auditId}`
    )
      .then(({ data }) => {
        if (loaderDispatch) loaderDispatch(setLoading(false));
        auditDispatch(setAuditQuestionnaireDetailById(data?.data));
        return Promise.resolve(data);
      })
      .catch((err) => {
        if (loaderDispatch) loaderDispatch(setLoading(false));
        if (err?.response?.data?.code === AUDIT_ON_HOLD) {
          auditDispatch(setAuditErrorCode(err?.response?.data?.code));
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "dnsd.selfAudit.auditOnHold")
          );
        } else if (err?.response?.data?.code === AUDIT_LINK_TOKEN_EXPIRE) {
          auditDispatch(setAuditErrorCode(err?.response?.data?.code));
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "dnsd.selfAudit.linkExpired")
          );
        } else if (err?.response?.data?.code === NO_QUESTIONNAIRE_ASSIGNED) {
          auditDispatch(setAuditErrorCode(err?.response?.data?.code));
        } else if (err?.response?.data?.code === AUDIT_MEDIUM_NOT_MATCH) {
          auditDispatch(setAuditErrorCode(err?.response?.data?.code));
        } else {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.somethingWentWrong")
          );
        }
      });
  }

  static async getAuditPreviewById({
    auditDispatch,
    loaderDispatch,
    auditId,
    intl,
  }) {
    loaderDispatch(setLoading(true));
    return Http.get(`${PRIVATE_API_ROUTES.AUDIT_PREVIEW}/${auditId}`)
      .then(({ data }) => {
        loaderDispatch(setLoading(false));
        auditDispatch(setAuditQuestionnaireDetailById(data?.data));
        return Promise.resolve(data);
      })
      .catch(() => {
        loaderDispatch(setLoading(false));
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
      });
  }

  static async saveQuestionResponse({ intl, payload }) {
    return Http.post(PRIVATE_API_ROUTES.SAVE_QUESTION_RESPONSE, payload)
      .then(({ data }) => {
        return Promise.resolve(data);
      })
      .catch((err) => {
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.resolve(err);
      });
  }

  static async updateAuditStatus({
    auditId,
    intl,
    loaderDispatch,
    body,
    isReAudit,
    successMessageCode = "savedSuccessFully",
    isDnsd,
  }) {
    loaderDispatch(setLoading(true));
    return Http.put(PRIVATE_API_ROUTES.UPDATE_AUDIT_STATUS(auditId), body)
      .then((res) => {
        loaderDispatch(setLoading(false));
        !isDnsd &&
          showNotification(
            "success",
            "Success",
            getLocalizedMessage(intl, successMessageCode)
          );
        return Promise.resolve(res?.data);
      })
      .catch((err) => {
        loaderDispatch(setLoading(false));
        if (err?.response?.data?.code === QUESTIONNAIRE_NOT_EVALUATED) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(
              intl,
              isReAudit
                ? "auditCompleted.evaluationStatusNotFilledReAudit"
                : "auditCompleted.evaluationStatusNotFilled"
            )
          );
        } else {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.somethingWentWrong")
          );
        }

        return Promise.resolve(err);
      });
  }

  static async sendLinkToDnsd({ auditId, intl, loaderDispatch, copyLink }) {
    loaderDispatch(setLoading(true));
    return Http.get(
      `${PRIVATE_API_ROUTES.SEND_LINK_TO_DNSD(auditId)}?link=${copyLink}`
    )
      .then((res) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "success",
          "Success",
          getLocalizedMessage(
            intl,
            copyLink
              ? "auditListing.msg.likCopied"
              : "auditListing.msg.sendLinkToDnsd"
          )
        );
        return Promise.resolve(res);
      })
      .catch((err) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.resolve(err);
      });
  }

  static async sendReportToSD({
    auditId,
    intl,
    loaderDispatch,
    download,
    format,
  }) {
    loaderDispatch(setLoading(true));
    return Http.get(
      `${PRIVATE_API_ROUTES.SEND_REPORT(auditId)}`,
      { download, format },
      () => {}, //NOSONAR
      download && "blob"
    )
      .then((res) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "success",
          "Success",
          getLocalizedMessage(
            intl,
            download
              ? "auditListing.msg.reportDownloaded"
              : "auditListing.msg.sendReportToDnsd"
          )
        );
        return Promise.resolve(res);
      })
      .catch((err) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.resolve(err);
      });
  }

  static async updateAudit({ auditId, intl, loaderDispatch, payload }) {
    loaderDispatch(setLoading(true));
    return Http.put(
      `${PRIVATE_API_ROUTES.UPDATE_AUDIT_TM(auditId)}`,
      payload
    )
      .then((res) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "success",
          "Success",
          getLocalizedMessage(intl, 'savedSuccessFully')
        );
        return Promise.resolve(res);
      })
      .catch((err) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.resolve(err);
      });
  }

  static async joinRemoteCallTM({ id, intl }) {
    return Http.get(`${PRIVATE_API_ROUTES.JOIN_REMOTE_CALL_TM(id)}`)
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.resolve(err);
      });
  }

  static async roomAccessToOthers({ intl, body }) {
    return Http.put(`${PRIVATE_API_ROUTES.ROOM_REQUEST}`, body)
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.resolve(err);
      });
  }

  static async recordEvidence({ intl, body }) {
    return Http.put(`${PRIVATE_API_ROUTES.RECORDING_EVIDENCE}`, body)
      .then((res) => {
        return Promise.resolve(res?.data);
      })
      .catch((error) => {
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.resolve(error);
      });
  }

  static async joinRemoteCall({ intl, auditId, isDnsd, auditDispatch }) {
    let url = PRIVATE_API_ROUTES.JOIN_REMOTE_CALL;
    if (auditId && !isDnsd) {
      url += `?auditId=${auditId}`;
    }
    return Http.get(url)
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        if (err?.response?.data?.code === AUDIT_LINK_TOKEN_EXPIRE) {
          if (auditDispatch) {
            auditDispatch(setAuditErrorCode(err?.response?.data?.code));
          }
        } else {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(
              intl,
              err?.response?.data?.code === NO_PARTICIPANT_FOUND
                ? "error.noParticipantFound"
                : "error.somethingWentWrong"
            )
          );
        }
        return Promise.resolve(err);
      });
  }
  static async updateFlags({ intl, documentId, body }) {
    return Http.put(`${PRIVATE_API_ROUTES.UPDATE_FLAGS}/${documentId}`, body)
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((er) => {
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.resolve(er);
      });
  }

  static async checkParticipant({ intl, auditId }) {
    return Http.get(`${PRIVATE_API_ROUTES.CHECK_PARTICIPANT}/${auditId}`)
      .then((res) => {
        return Promise.resolve(res?.data);
      })
      .catch((err) => {
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.resolve(err);
      });
  }
}

export default AuditService;
